<template lang="pug">
#CreateEditForm
  b-form(@submit.stop.prevent="onSubmit", novalidate)
    b-row
      b-col(cols="6")
        b-form-group#input-group-name(
          label="Nombre",
          label-for="input-name-user"
        )
          b-form-input#input-name-user(
            v-model="form.name",
            placeholder="Nombre"
            :state="$v.$dirty ? !$v.form.name.$invalid : null"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.name.required") Campo requerido
            
      b-col(cols="6")
        b-form-group#input-group-lastName(
          label="Apellido",
          label-for="input-lastName"
        )
          b-form-input#input-lastName(
            v-model="form.lastName",
            placeholder="Apellido"
            :state="$v.$dirty ? !$v.form.lastName.$invalid : null"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.lastName.required") Campo requerido
            
    b-row
      b-col(cols="6")
        b-form-group#input-group-email(
          label="Email",
          label-for="input-email"
        )
          b-form-input#input-email(
            v-model="form.email",
            type="email",
            placeholder="email@email.cl"
            :state="$v.$dirty ? !$v.form.email.$invalid : null"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(:state="$v.form.email.required") Campo requerido
            b-form-invalid-feedback(:state="$v.form.email.email") Debe ser un email válido
      b-col(cols="6")
        b-form-group#input-group-password(
          :label="this.action === 'create' ? 'Contraseña' : 'Cambiar contraseña (opcional)'",
          label-for="input-password"
        )
          b-form-input#input-password(
            v-model="form.password",
            type="password",
            :state="$v.$dirty ? !$v.form.password.$invalid : null"
          )
          .errors(v-if="$v.$dirty")
            b-form-invalid-feedback(v-if="this.action==='create'" :state="$v.form.password.required") Campo requerido
            b-form-invalid-feedback(:state="$v.form.password.minLength") 
              | La contraseña debe contener {{$v.form.password.$params.minLength.min}} o más caracteres
    .modal-footer
      b-button(@click="hideModal()", variant="outline-muted") Cancelar
      b-button(type="submit") {{ action === 'create' ? 'Crear' : 'Editar' }}
</template>
<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
export default {
  props: ["selectedUser", "action", "hideModal", "makeToast"],
  validations () {
    let validations = {
      form : {
        name: { required },
        lastName: { required },
        email: {
          required,
          email,
        },
        password: { minLength: minLength(6) }
      }
    }
    if (this.action === 'create') {
      validations.form.password.required = required
    } 
    return validations
  },
  data() {
    return {
      form: {
        id: this.action === "create" ? null : this.selectedUser.id,
        name: this.action === "create" ? null : this.selectedUser.name,
        lastName: this.action === "create" ? null : this.selectedUser.lastName,
        email: this.action === "create" ? null : this.selectedUser.email,
        password: '',
        businessId: this.$route.params.id,
        role: 'client'
      },
    };
  },
  methods: {
    ...mapActions("UserStore", ["createUser", "updateUser"]),
    async onSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        let payload = { ...this.form }
        if (payload.password === '') {
          delete payload.password
        }
        const action = this.action === "create" ? this.createUser : this.updateUser;
        const response = await action(payload);

        if (response.status === 200 || response.status === 201) {
          const message = this.action === "create" ?
            'El usuario ha sido creado exitosamente' : 'El usuario se editó correctamente'
          this.$root.$bvToast.toast(message, {
            title: 'Exito!',
            variant: 'success'
          })
          this.hideModal();
        } else {
          this.$root.$bvToast.toast(response.data.message, {
            title: 'Oops!',
            variant: 'danger'
          })
        }
      }
    },
  },
};
</script>
